import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { parseNumber, strict } from "@apl-digital/utils";
import * as Sentry from "@sentry/react";

import config from "@/constants/config";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  release: import.meta.env.VITE_SENTRY_RELEASE,
  normalizeDepth: 10,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.extraErrorDataIntegration({
      captureErrorCause: true,
    }),
  ],

  beforeSend(event, hint) {
    const error = hint?.originalException;
    if (error instanceof DOMException && error.name === "AbortError") {
      return null;
    }
    return event;
  },

  tracePropagationTargets: ["localhost", config.apiConfig.loyaltyProxy.url],

  // Performance Monitoring
  tracesSampleRate: strict(
    parseNumber(import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE),
  ),
  profilesSampleRate: strict(
    parseNumber(import.meta.env.VITE_SENTRY_PROFILES_SAMPLE_RATE),
  ),
});
